//

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiService } from 'src/app/services/api.service';
import { CluWCashDeskMLoyaltyLandingClientItem } from './m-loyalty-landing.model';

@Injectable()
export class ConnectorWCashDeskLoyaltyLandingService {

    constructor(private httpClient: HttpClient, private apiService : ApiService) {
    }

    doSaveWLoyaltyCardClientItemAction_PUPCashDeskLoyalty(_lcClientItem : CluWCashDeskMLoyaltyLandingClientItem){
        return this.httpClient.post(this.apiService.endPointsPU.doSaveWLoyaltyCardClientItemAction_PUPCashDeskLoyalty, _lcClientItem);
    }
    
}